module.exports = __webpack_public_path__ + "img/서브3_공제어감각.b2e369d1.svg";